<template>
  <a-modal :forceRender="true" :visible="value" :title="title" :maskClosable="true" :closable="closable" :destroyOnClose="true" @cancel="handleCancel" @ok="handleOk" :width="width" :keyboard="true">
    <div class="search-all-box add-modal">
      <a-form ref="addForm" :form="stadiumForm" :label-col="labelCol" :wrapper-col="wrapperCol" style="width: 100%">
        <a-form-item label="入物名称：">
          <a-input class="search-input" v-decorator="rules.name" placeholder="请输入物名称"></a-input>
        </a-form-item>
        <a-form-item label="入物简介：" :labelCol="{ span: 4}" :wrapperCol="{ span: 24 }">
          <div v-decorator="rules.intro">
            <qEditor :height400="'height400'" :imgLabel="'venue_person_cover'" :valuetxt="editorCon" @inputChange="changeContent"></qEditor>
          </div>
        </a-form-item>
        <a-form-item label="入物封面图：">
          <div class="img-content" v-decorator="rules.cover">

            <div class="upload-btn" @click="$refs.uploadImg.click()">上传</div>
            <input name="img" ref="uploadImg" @change="uploadImg" type="file" multiple style="display: none;">
            <div class="img-cover" :class="{empty: imgUrl.length< 1}">
              <div class="cover-item" @click="previewUrl = item" v-for="(item,ind) in imgUrl" :key="ind" :style="`background-image: url('${item}')`">
                <div class="item-delete" @click.stop="deleteCover(item)">删除</div>
              </div>
            </div>
          </div>
        </a-form-item>

      </a-form>
    </div>
    <!-- 上传进度 -->
    <a-spin :tip="`上传中...`" :spinning="uploadImgStatus == 'uploading'&& quillUpdateImg">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>
    <loading v-if="loading"></loading>
      <div class="img-preview" v-if="previewUrl">
      <div class="close-text" @click="previewUrl = ''">x</div>
      <img :src="previewUrl" alt="">
    </div>
  </a-modal>

</template>

<script>
import qEditor from '../QuillEditor.vue'
import services from '../../assets/js/services';
import loading from '../../components/loading.vue';

import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import { mapActions } from "vuex";
export default {
  props: {
    value: Boolean,
    title: {
      type: String,
      default: '添加人物'
    },
    closable: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取 消'
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: '确 定'
    },
    confirmLoading: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: null
    },
    characterId: {
      type: [String, Number],
      default: null
    },
    venue_id: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    qEditor,
    loading
  },
  data() {
    let that = this
    return {
      loading: false,
      labelCol: {
        xs: { span: 4 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 20 },
        sm: { span: 20 },
      },
      stadiumForm: this.$form.createForm(this, { name: 'addCharacter' }),
      addForm: {
        name: "",

        intro: "",
        cover: "",
      },
      rules: {
        name: [
          'name',
          {
            rules: [

              {
                required: true,
                message: '请输入人物名称!',
              },
            ],
          },
        ],

        intro: [
          'intro',
          {
            initialValue: that.article_content,
            rules: [
              {
                required: true,
                message: '请输入人物简介!',
              },

            ],
          },
        ],
        cover: [
          'cover',
          {
            rules: [
              {
                required: true,
                message: '请上传封面图!',
              },

            ],
          },
        ],
      },
      editorCon: '', // 编辑器内容
      stadiumType: [],
      map: null,
      markerLayer: null,
      suggest: null,
      mapValue: "",
      mapValueList: [],
      uploadImgStatus: "",
      quillUpdateImg: false,
      imgUrl: [],
      limitSize: 1024 * 1024 * 10, // 10MB
      fileData: {
        progress: 0
      }, // 上传图片数据
      previewUrl: ""
    }
  },
  computed: {
    myValue() {
      return this.value;
    }
  },
  watch: {
    myValue: {
      handler(newVal) {
        if (newVal) {
          this.editorCon = ""
          this.imgUrl = []
        }
      }
    },
    characterId: {
      handler(newVal) {
        if (newVal) {
          this.getStadiumInfo(newVal)
          // this.stadiumForm.resetFields()
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    ...mapActions(["getCharacter", "editCharacter", "addCharacter", "getCharacterInfo"]),
    handleCancel() {
      this.$emit('input', false); // 触发 v-model 更新
      this.$emit('cancel');
    },
    uploadImg() {
      let file = this.$refs.uploadImg.files;
      let uploadList = []
      if (file.length > 0) {
        for (let i = 0; i < file.length; i++) {

          uploadList.push(this.handleUpload(file[i]))
        }
        Promise.all(uploadList).then(values => {
          console.log(values);
          if (values.every(ele => ele)) {
            this.quillUpdateImg = false
            this.uploadImgStatus = 'success'
          }
        }).catch(error => {
          this.quillUpdateImg = false
          this.uploadImgStatus = 'error'
          console.error("上传失败", error);
        });
      }

    },
    getStadiumInfo(id) {
      this.getCharacterInfo({ id: id, data: { venue_id: this.venue_id } }).then(res => {
        if (res.code == "0000" && res.data) {
          let data = res.data
          this.stadiumForm.setFieldsValue({
            name: data.name,
            intro: data.intro,
            cover: data.cover.split(","),
          })
          this.editorCon = data.intro
          this.imgUrl = data.cover.split(",")
          this.vrLInk = data.vr_url
          // 设置地图位置

        }
      })
    },
    handleOk() {
      //   this.$emit('confirm')
      this.stadiumForm.validateFields(async err => {
        if (!err) {
          let params = this.stadiumForm.getFieldsValue()
          for (let key in params) {
            if (params[key] == undefined) {
              params[key] = ''
            }
          }
          console.log(params);
          this.loading = true
          const formData = new FormData();
          formData.append("cover", params.cover.join(","));
           // intro 为富文本字符串，请求前对其中的 HTML 标签进行转义
          if (params.intro && typeof params.intro === 'string') {
            params.intro = params.intro.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
          }
          formData.append("intro", params.intro);
          formData.append("name", params.name);
          formData.append("venue_id", this.venue_id);
          if (this.characterId) {
            formData.append("_method", "put");
            let result = await services.editCharacter({ id: this.characterId, data: formData })
            if (result.code == "0000") {
              this.$message.success("编辑成功")
              this.handleCancel()
              this.$emit('confirm')
              this.editorCon = ""
              this.imgUrl = []
            } else {
              this.$message.error(result.message)
            }
          } else {
            let result = await services.addCharacter(formData)
            if (result.code == "0000") {
              this.$message.success("添加成功")
              this.handleCancel()
              this.$emit('confirm')
              this.editorCon = ""
              this.imgUrl = []
            } else {
              this.$message.error(result.message)
            }
          }
          this.loading = false
        }
      });

    },


    changeContent(con) {
      this.stadiumForm.setFieldsValue({ intro: con })
    },
    handleUpload(file) {
      return new Promise((res, rej) => {
        let that = this
        const imageRegex = /\.(png|jpg|jpeg)$/i;
        console.log(imageRegex.test(file.name));

        // 使用示例
        if (!imageRegex.test(file.name)) return that.$message.info(`请上传PNG,JPG,JPE格式的图片`)
        if (file.size > that.limitSize) return that.$message.info(`请上传不超过${that.limitText}的图片`)
        that.uploadImgStatus = 'uploading'
        that.quillUpdateImg = true
        that.fileData = {
          filename: file.name, // 附件名称
          progress: 0, // 上传进度
          view_url: URL.createObjectURL(file),
          path: ''
        }

        const chunkSize = 1024 * 1024 * 3; // 3MB
        const totalChunks = Math.ceil(file.size / chunkSize); // 计算文件总片数
        const uuid = uuidv4() // 文件唯一标识
        let currentChunk = 0; // 当前上传的分片索引
        let uploadedBytes = 0; // 已上传的总字节数

        function uploadChunk() {
          const start = currentChunk * chunkSize;
          const end = Math.min(start + chunkSize, file.size);
          const data = file.slice(start, end);
          const formData = new FormData();
          formData.append("file", data, file.name);
          formData.append("label", "venue_person_cover ");
          formData.append("is_tmp", "1");
          formData.append("uuid", uuid);
          formData.append("chunks", totalChunks);
          formData.append("chunk", currentChunk);
          // 发送分片数据
          axios.post(`${services.HOST}/api/upload/file`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (progressEvent) => {
              const chunkUploadedBytes = progressEvent.loaded;
              uploadedBytes = currentChunk * chunkSize + chunkUploadedBytes;
              // 更新上传进度
              let percent = Math.round((uploadedBytes / file.size) * 100);
              if (percent > that.fileData.progress) {
                that.fileData.progress = percent > 100 ? 100 : percent;
              }
            }
          }).then(({ data: result }) => {
            if (currentChunk < totalChunks - 1) {
              // 继续上传下一片
              currentChunk++;
              uploadChunk();
            } else {
              // that.quillUpdateImg = false
              if (result.code == "0000") {
                // that.uploadImgStatus = 'success'
                that.$set(that.fileData, 'progress', 100)
                that.$set(that.fileData, 'view_url', result.data.url)
                that.$set(that.fileData, 'path', result.data.path)
                that.imgUrl.push(result.data.url)
                that.stadiumForm.setFieldsValue({ cover: that.imgUrl })
                res(true)
              } else {
                that.$message.error("图片插入失败")
                that.fileData = null
                that.uploadImgStatus = 'error'
                res(false)

              }

            }
          }).catch((error) => {
            // that.quillUpdateImg = false
            // that.uploadImgStatus = 'error'
            console.error("上传失败", error);
            rej()
          });
        }

        // 开始上传第一片
        uploadChunk();
      })

    },
    deleteCover(item) {
      this.imgUrl = this.imgUrl.filter(i => i !== item)
      this.stadiumForm.setFieldsValue({ cover: this.imgUrl })
    }
  }
}
</script>

<style lang="less" scoped>
.img-preview {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    max-width: 100%;
    max-height: 100%;
  }
  .close-text {
    font-size: 18px;
    color: #fff;
    position: absolute;
    top: 10px;
    right: 15px;
    cursor: pointer;
  }
}
.search-all-box.add-modal {
  width: 605px;
  .map-content {
    position: relative;
    margin-bottom: 20px;
    .map {
      width: 100%;
      height: 300px;
    }
    .map-sreach {
      position: absolute;
      top: 10px;
      left: 20px;
      z-index: 1001;
    }
  }
  .vr-content {
    display: flex;
    align-items: center;
    .vr-link {
      display: inline-block;
      color: #1890ff;
      cursor: pointer;
      white-space: nowrap;
      margin-left: 10px;
    }
  }

  .img-content {
    padding-top: 8px;
    .img-cover {
      display: flex;
      flex-wrap: wrap;
      .cover-item {
        width: 160px;
        height: 90px;
        border: 1px solid #d9d9d9;
        background-size: cover;
        background-position: center;
        margin-right: 8px;
        margin-bottom: 8px;
        position: relative;
        .item-delete {
          display: block;
          position: absolute;
          top: 0;
          right: 0;
          line-height: 1.5;
          padding: 0 5px;
          background: rgb(255, 187, 39);
          color: #fff;
          cursor: pointer;
        }
      }

      &.empty {
        &::before {
          content: "请上传封面图";
          display: block;
          width: 160px;
          height: 90px;
          line-height: 90px;
          background-color: #f5f5f5;
          text-align: center;
          font-size: 14px;
          color: #999;
        }
      }
    }
    .upload-btn {
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #1890ff;
      color: #fff;
      border-radius: 4px;
      cursor: pointer;
      margin-bottom: 20px;
      position: relative;
      &::before {
        content: "请上传的640px：360px，.png,.jpg,.jpeg 图片，图片大小小于5M";
        color: rgb(255, 187, 39);
        line-height: 1.1;
        position: absolute;
        // top: 35px;
        left: 80px;
        width: 350px;
        margin-left: 10px;
      }
    }
  }
  /deep/.ant-form-explain {
    // line-height: 1.2;
    margin-top: 5px;
  }
}
</style>